import { exchange } from "@ls/js-fetch";
import {
  fetchEntities,
  fetchSelectionSecurityAttributes,
} from "../../queryClient";
export const SET_MODE = "selection/SET_MODE";
export const setMode = (mode) => ({
  type: SET_MODE,
  mode,
});

export const SET_INSTRUMENT_TYPES_INCLUDE_OPTION = "selection/SET_INSTRUMENT_TYPES_INCLUDE_OPTION";
export const setInstrumentTypesIncludeOption = (option) => ({
  type: SET_INSTRUMENT_TYPES_INCLUDE_OPTION,
  option,
});

export const SET_DISPLAY_RGL = "selection/SET_DISPLAY_RGL";
export const setIsDisplayRgl = (isDisplayRgl) => ({
  type: SET_DISPLAY_RGL,
  isDisplayRgl,
});

export const SET_IS_SHOW_CANCLED_TRADES = "selection/SET_IS_SHOW_CANCLED_TRADES";
export const setIsShowCanceledTrades = (isShowCanceledTrades) => ({
  type: SET_IS_SHOW_CANCLED_TRADES,
  isShowCanceledTrades,
});

export const SET_REPLACE_MAJORS_WITH_MINORS = "selection/SET_REPLACE_MAJORS_WITH_MINORS";
export const setReplaceMajorsWithMinors = (replaceMajorsWithMinors) => ({
  type: SET_REPLACE_MAJORS_WITH_MINORS,
  replaceMajorsWithMinors,
});



export const SET_ENTITY_IDS = "selection/SET_ENTITY_IDS";
export const setEntityIds = (value) => ({
  type: SET_ENTITY_IDS,
  value,
});

export const ADD_ENTITY_ID = "selection/ADD_ENTITY_ID";
export const addEntityId = (entityId) => ({
  type: ADD_ENTITY_ID,
  entityId,
});

export const SET_SELECTED_AS_OF_DATE = "selection/SET_SELECTED_AS_OF_DATE";
export const setSelectedAsOfDate = (asOfDate) => ({
  type: SET_SELECTED_AS_OF_DATE,
  asOfDate,
});

export const SET_SELECTED_AS_OF_DATE_START =
  "selection/SET_SELECTED_AS_OF_DATE_START";
export const setSelectedAsOfDateStart = (asOfDateStart) => ({
  type: SET_SELECTED_AS_OF_DATE_START,
  asOfDateStart,
});

export const SET_SYMBOLIC_DATE = "selection/SET_SYMBOLIC_DATE";
export const setSymbolicDate = (symbolicDate) => ({
  type: SET_SYMBOLIC_DATE,
  symbolicDate,
});

export const SET_SYMBOLIC_DATE_START = "selection/SET_SYMBOLIC_DATE_START";
export const setSymbolicDateStart = (symbolicDateStart) => ({
  type: SET_SYMBOLIC_DATE_START,
  symbolicDateStart,
});

export const GROUP_TYPE_SET = "selection/GROUP_TYPE_SET";
export const setGroupType = (groupType) => ({
  type: GROUP_TYPE_SET,
  groupType,
});

export const GROUP_SET = "selection/GROUP_SET";
export const setGroup = (groups) => ({ 
  type: GROUP_SET, 
  groups 
});



export const GROUPS_REQUEST = "selection/GROUPS_REQUEST";
export const requestGroups = (groupType) => ({
  type: GROUPS_REQUEST,
  groupType,
});

export const GROUPS_RECEIVE = "selection/GROUPS_RECEIVE";
export const receiveGroups = (groupType, data) => ({
  type: GROUPS_RECEIVE,
  groupType,
  data,
});

export const LOCAL_CURRENCY_FILTER_SET = "selection/LOCAL_CURRENCY_FILTER_SET";
export const setLocalCurrencyFilter = (localCurrencyCodes) => ({ 
  type: LOCAL_CURRENCY_FILTER_SET, 
  localCurrencyCodes 
});

export const OFFERING_MARKET_FILTER_SET = "selection/OFFERING_MARKET_FILTER_SET";
export const setOfferingMarketsFilter = (offeringMarkets) => ({
  type: OFFERING_MARKET_FILTER_SET,
  offeringMarkets
});

export const TRANSACTION_CODE_FILTER_SET = "selection/TRANSACTION_CODE_FILTER_SET";
export const setTransactionCodeFilter = (transactionCodes) => ({ 
  type: TRANSACTION_CODE_FILTER_SET, 
  transactionCodes 
});

export const MAJOR_MINOR_ADJUSTMENT = "selection/MAJOR_MINOR_ADJUSTMENT";
export const setMajorMinorAdjustment = (majorMinorAdjustment) => ({ 
  type: MAJOR_MINOR_ADJUSTMENT, 
  majorMinorAdjustment 
});

export const SECURITY_IDS_FILTER_SET = "selection/SECURITY_IDS_FILTER_SET";
export const setSecurityIdsFilter = (securityIds) => ({ 
  type: SECURITY_IDS_FILTER_SET, 
  securityIds 
});

export const CLEAR_REMOVED_SELECTION_FILTERS_DIALOG = "selection/CLEAR_REMOVED_SELECTION_FILTERS_DIALOG";
export const clearRemovedSelectionFiltersDialog = () => ({
  type: CLEAR_REMOVED_SELECTION_FILTERS_DIALOG,
});

export const INSTRUMENT_TYPE_FILTER_SET = "selection/INSTRUMENT_TYPE_FILTER_SET";
export const setInstrumentTypesFilter = (instrumentType) => ({ 
  type: INSTRUMENT_TYPE_FILTER_SET, 
  instrumentType 
});

export const TRANSACTION_EFFECT_FILTER_SET = "selection/TRANSACTION_EFFECT_FILTER_SET";
export const setTransactionEffectFilter = (transactionEffects) => ({ 
  type: TRANSACTION_EFFECT_FILTER_SET, 
  transactionEffects
});

export const TICKER_FILTER_SET = "selection/TICKER_FILTER_SET";
export const setTickerFilter = (tickers) => ({ 
  type: TICKER_FILTER_SET, 
  tickers 
});

export const ABS_MSAA_SECTOR_FILTER_SET = "selection/ABS_MSAA_SECTOR_FILTER_SET";
export const setMsaaFilter= (absMsaaSector) => ({ 
  type: ABS_MSAA_SECTOR_FILTER_SET, 
  absMsaaSector 
});

export const MSAA_BUCKET_FILTER_SET = "selection/MSAA_BUCKET_FILTER_SET";
export const setMsaaBucketFilter = (msaaBucketCodes) => ({
  type: MSAA_BUCKET_FILTER_SET,
  msaaBucketCodes,
});

export const TRADER_FILTER_SET = "selection/TRADER_FILTER_SET";
export const setTraderIds= (traderIds) => ({ 
  type: TRADER_FILTER_SET, 
  traderIds 
});



export const REQUEST_ENTITIES = "selection/REQUEST_ENTITIES";
export const RECEIVE_ENTITIES = "selection/RECEIVE_ENTITIES";
export const REQUEST_ENTITIES_FAILED = "selection/REQUEST_ENTITIES_FAILED";
export const requestEntitiesStarted = (query) => ({
  type: REQUEST_ENTITIES,
  query,
});

export const receiveEntities = (query, data) => ({
  type: RECEIVE_ENTITIES,
  query,
  data,
});

export const requestEntitiesFailed = (query, error) => ({
  type: REQUEST_ENTITIES_FAILED,
  query,
  error,
});

export const loadEntities = (query, isCanceled = () => false) => {
  return async (dispatch) => {
    dispatch(requestEntitiesStarted(query));

    try {
      const data = await fetchEntities(query);

      if (isCanceled()) {
        return;
      }

      dispatch(receiveEntities(query, data));
    } catch (error) {
      if (isCanceled()) {
        return;
      }

      dispatch(requestEntitiesFailed(query, error));
    }
  };
};

export const REQUEST_HOLDING_ATTRIBUTES = "selection/REQUEST_HOLDING_ATTRIBUTES";
export const RECEIVE_HOLDING_ATTRIBUTES = "selection/RECEIVE_HOLDING_ATTRIBUTES";

export const requestHoldingAttributes = () => {
  
  return async (dispatch) => {
    dispatch({ type: REQUEST_HOLDING_ATTRIBUTES });
    const params = {
        appName:process.env.REACT_APP_ID,
    }
    const url = 'Holding.json'
    dispatch({
      type: RECEIVE_HOLDING_ATTRIBUTES,
      data:(
        await exchange({  
          baseURL: `${process.env.REACT_APP_BASE_URL_ENTITY_SERVICE}/rest/query/describe`,
          url,
          params
        }) 
      )?.data.results
    });
  };
};

export const REQUEST_IN2_USERS = "selection/REQUEST_IN2_USERS";
export const RECEIVE_IN2_USERS = "selection/RECEIVE_IN2_USERS";

export const requestIn2Users = () => {
  
  return async (dispatch) => {
    dispatch({ type: REQUEST_IN2_USERS });
    dispatch({
      type: RECEIVE_IN2_USERS,
      data:(
        await exchange({  
          baseURL: process.env.REACT_APP_BASE_URL_IN2_USERS,
          dontSendBearerToken : true
        }) 
      )?.data
    });
  };
};


export const REMOVE_ENTITY_ID = "selection/REMOVE_ENTITY_ID";
export const removeEntityId = (entityId) => ({
  type: REMOVE_ENTITY_ID,
  entityId,
});

export const COMMIT_SELECTIONS = "selection/COMMIT_SELECTIONS";
export const commitSelections = () => ({
  type: COMMIT_SELECTIONS,
});


export const REQUEST_SELECTION_SECURITY_ATTRIBUTES = "selection/REQUEST_SELECTION_SECURITY_ATTRIBUTES";
export const RECEIVE_SELECTION_SECURITY_ATTRIBUTES = "selection/RECEIVE_SELECTION_SECURITY_ATTRIBUTES";
export const REQUEST_SELECTION_SECURITY_ATTRIBUTES_FAILED = "selection/REQUEST_SELECTION_SECURITY_ATTRIBUTES_FAILED";
export const requestSelectionSecurityAttributesStarted = (query) => ({
  type: REQUEST_SELECTION_SECURITY_ATTRIBUTES,
  query,
});

export const receiveSelectionSecurityAttributes = (query, data) => ({
  type: RECEIVE_SELECTION_SECURITY_ATTRIBUTES,
  query,
  data,
});

export const requestSelectionSecurityAttributesFailed = (query, error) => ({
  type: REQUEST_SELECTION_SECURITY_ATTRIBUTES_FAILED,
  query,
  error,
});

export const loadSelectionSecurityAttributes = (
  query,
  isCanceled = () => false
) => {
  return async (dispatch) => {
    dispatch(requestSelectionSecurityAttributesStarted(query));

    try {
      const data = await fetchSelectionSecurityAttributes(query);

      if (isCanceled()) {
        return;
      }

      dispatch(receiveSelectionSecurityAttributes(query, data));
    } catch (error) {
      if (isCanceled()) {
        return;
      }

      dispatch(requestSelectionSecurityAttributesFailed(query, error));
    }
  };
};
